var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['techVideo']},[_c('div',{staticClass:"tvWrapper"},[_c('div',{staticClass:"tvVideo",domProps:{"innerHTML":_vm._s(_vm.compData.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }